import React from 'react';
import { connect } from 'react-redux';
import FreshdeskWidget from 'common/components/FreshdeskWidget';
import FreshdeskAPI from 'common/modules/authentication/services/FreshdeskAPI';
import { statsRadioFreshdeskWidgetId } from 'common/config/config';
import { getToken, getUserLanguage, isAuthenticated } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import { getCurrentLanguage } from 'common/i18n/i18n';

const freshdeskWidgetLabels: WidgetLabels = {
  'fr': {
    banner: 'Support',
    launcher: 'Aide',
    contact_form: {
      title: 'Contactez nous',
      submit: 'Envoyer',
      confirmation: 'Nous vous reviendrons bientôt.',
    },
  },
  'en': {
    banner: 'Support',
    launcher: 'Help',
    contact_form: {
      title: 'Contact Us',
      submit: 'Send',
      confirmation: 'Thank you for your feedback.',
    },
  },
};

type Props = {
  token: string,
  language: string,
  isAuthenticated: Boolean,
}

type State = {
  freshdeskToken: string,
}

class StatsRadioSupportWidget extends React.Component<Props, State> {
  state = {
    freshdeskToken: undefined,
  }

  async componentWillReceiveProps(nextProps: Props) {
    if (nextProps.isAuthenticated && nextProps.token) {
      const freshdeskToken = await FreshdeskAPI.authenticate(nextProps.token);
      this.setState({ freshdeskToken });
    }
  }

  render() {
    return (
      <FreshdeskWidget
        freshdeskToken={this.state.freshdeskToken}
        language={this.props.language}
        defaultLanguage={getCurrentLanguage()}
        widgetId={statsRadioFreshdeskWidgetId}
        labels={freshdeskWidgetLabels}
      />
    );
  }
}

function mapStateToProps(state: AppState) {
  return {
    language: getUserLanguage(state),
    token: getToken(state),
    isAuthenticated: isAuthenticated(state),
  };
}

export default connect(mapStateToProps)(StatsRadioSupportWidget);



// WEBPACK FOOTER //
// ./src/common/components/StatsRadioSupportWidget.js